import { z } from 'zod';
import { LOGGING_FORMAT } from './helpers/enums.ts';

export const loggingFormatSchema = z.enum([...LOGGING_FORMAT, '']);

export const loggingFormatRequiredSchema = loggingFormatSchema.refine((val) => val !== '', {
  message: 'Choose a log output format',
});

export const loggingFormatStrictSchema = z.enum(LOGGING_FORMAT);
